/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Container from "@/common/Layout/Container/Container";
import useAuth from "@/hooks/useAuth";
import useTrans from "@/hooks/useTrans";
import { useLocalContext } from "@/setup/locale-provider";
import { appAlert } from "@/setup/mantine-provider/notifications";
import { getFromStorage, setToStorage } from "@/utils/localStorage";
import {
  Box,
  Button,
  Card,
  Center,
  Group,
  Modal,
  PasswordInput,
  Text,
  TextInput,
  Title,
  UnstyledButton,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import dynamic from "next/dynamic";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import OtpForm from "../dang-ky/components/OtpForm";
import FbLogin from "./components/FbLogin";
import ForgetPassForm from "./components/ForgetPassForm";
import GgLogin from "./components/GgLogin";

const ReCAPTCHA = dynamic(() => import("../../common/ReCapcha.js"));

export default function DangNhap() {
  const trans = useTrans();
  const { getLabel } = useLocalContext();
  const router = useRouter();
  const { login, sendOtp, authOtp, resend, resetPassword } = useAuth();
  const [opened, setOpened] = React.useState(false);
  const [forgetPass, setForgetPass] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState(false);
  const [isReCaptchaNeeded, setIsReCaptchaNeeded] = React.useState(false);

  React.useEffect(() => {
    const hasToken = Boolean(getFromStorage("token"));
    if (hasToken) {
      router.push("/");
    }
  }, []);

  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },
    validate: {
      email: (value) =>
        value.length > 0
          ? null
          : trans?.login.validate.blank,
      password: (value) =>
        value.length > 0 ? null : trans?.login.validate.blankPassword,
    },
  });

  const handleSubmit = async () => {
    try {
      const rs_login = await login(form.values.email, form.values.password);

      if (rs_login.status) {
        router.back();
      } else if (rs_login.require_verify) {
        const rs_otpInfo = await sendOtp(form.values.email);
        if (rs_otpInfo.status) {
          setModalTitle(rs_login.message);
          setOpened(true);
        } else {
          form.setErrors({ email: rs_otpInfo.message });
          // console.log("a", form.values.email);
        }
      } else {
        form.setErrors({ email: rs_login.message });
      }
    } catch (error) {
      console.log(
        "Error handleSubmit => ",
        error.data.message || error.message || error.error || error
      );
      form.setErrors({
        email: error.data.message || error.message || error.error || error,
      });
    }
  };

  // const resend = async () => {
  //   try {
  //     let rs_otpInfo = await sendOtp(form.values.email);
  //     if (rs_otpInfo.status) {
  //       return {
  //         status: true,
  //         message: `Mã xác thực đã gửi đến ${form.values.email}`,
  //       };
  //     } else {
  //       return {
  //         status: false,
  //         message: `Gửi lại mã xác thực không thành công`,
  //       };
  //     }
  //   } catch (error) {
  //     console.log(
  //       "Error handleSubmit => ",
  //       error.message || error.error || error
  //     );
  //     return {
  //       status: false,
  //       message: `Gửi lại mã xác thực không thành công`,
  //     };
  //   }
  // };

  return (
    <Box component="div" py="lg">
      <Head>
        <title>{trans?.login.seoTitle}</title>
      </Head>
      <Container size="sm" sx={{ height: "100%" }}>
        <Card shadow="sm" p="lg" radius="md" withBorder>
          <Center>
            <Title order={3}>{trans?.login.title}</Title>
          </Center>
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <TextInput
              withAsterisk
              label={trans?.login.username}
              labelProps={{ style: { color: "#000" } }}
              {...form.getInputProps("email")}
              placeholder={trans?.login.placeholder.username}
              onFocus={() => {
                setIsReCaptchaNeeded(true);
              }}
              mb={5}
            />
            <PasswordInput
              withAsterisk
              label={trans?.login.password}
              labelProps={{ style: { color: "#000" } }}
              {...form.getInputProps("password")}
              placeholder={trans?.login.placeholder.password}
              mb={5}
            />
            <Group position="right">
              <UnstyledButton>
                <Text
                  size="sm"
                  color="blue"
                  onClick={() => setForgetPass(true)}
                >
                  {trans?.login.forgotPass}
                </Text>
              </UnstyledButton>
            </Group>

            <Group position="center">
              <Button
                type="submit"
                mt="sm"
                fullWidth
                variant="outline"
                color="dark"
              >
                <Text weight="500" transform="uppercase">
                  {trans?.login.submit}
                </Text>
              </Button>
            </Group>
          </form>
          <Center>
            <Box
              sx={(theme) => ({
                display: "flex",
                [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
                  flexDirection: "column",
                  justifyContent: "center",
                },
              })}
              mt={10}
            >
              <Text size="sm" mr={4}>
                {trans?.login.swap}
              </Text>
              <Link
                scroll={false}
                href="/dang-ky"
                replace
                // onClick={(e) => {
                //   e.preventDefault();
                //   router.replace("/dang-ky");
                // }}
              >
                <a>
                  <Text
                    weight="700"
                    transform="uppercase"
                    size="sm"
                    align="center"
                  >
                    {trans?.login.signup}
                  </Text>
                </a>
              </Link>
            </Box>
          </Center>
          <Center my={10}>
            <Text size="sm" transform="uppercase">
            {trans?.login.or}
            </Text>
          </Center>
          <Box sx={(theme) => ({
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            [`${theme.fn.smallerThan("sm")}`]: {
              flexDirection: "column",
              height: 90
            }
          })}>
            <FbLogin />
            <GgLogin />

          </Box>
          <Group position="center" align="center" grow />

          {/* <Box
            sx={(theme) => ({
              display: "flex",
              justifyContent: "space-between",
              [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
                flexDirection: "column",
                // justifyContent: "center",
              },
            })}
          >
            <FbLogin />
            <GgLogin />
          </Box> */}
        </Card>
        <Modal
          opened={opened}
          onClose={() => setOpened(false)}
          title={getLabel(modalTitle)}
        >
          <OtpForm
            authOtp={authOtp}
            resend={resend}
            callback={(rs) => {
              setToStorage("token", rs.token);
              setToStorage("updateInfo", true);

              router.back();
            }}
          />
        </Modal>
        <Modal
          opened={forgetPass}
          onClose={() => setForgetPass(false)}
          title={trans?.forgotPassword.title}
        >
          <ForgetPassForm
            sendOtp={sendOtp}
            authOtp={authOtp}
            resend={resend}
            resetPassword={resetPassword}
            callback={(rs) => {
              appAlert({ type: "success", message: rs.message });
              setForgetPass(false);
            }}
          />
        </Modal>
      </Container>
      {isReCaptchaNeeded && <ReCAPTCHA />}
    </Box>
  );
}
